"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[9211],{

/***/ 96078:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78364);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69541);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51827);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50556);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17382);
/* harmony import */ var compositions_Header_Header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99025);
/* harmony import */ var compositions_Footer_Footer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25413);









var MainLayout = function(param) {
    var children = param.children, contentWrapperClassName = param.contentWrapperClassName, _param_withHeaderBanner = param.withHeaderBanner, withHeaderBanner = _param_withHeaderBanner === void 0 ? true : _param_withHeaderBanner;
    var isInAppMessagesCenterEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.abTests.inAppMessagesCenter) === "b";
    var isQueueHeaderCounterEnabled = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(helpers__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.abTests.queueHeaderCounter) === "b";
    var _useUser = (0,modules_user__WEBPACK_IMPORTED_MODULE_4__/* .useUser */ .a)(), isLoggedIn = _useUser.isLoggedIn, user = _useUser.user;
    // ATTN if user is authenticated we should use internal main page instead of home for every internal page
    var headerLogoLink = isLoggedIn ? links__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP.subscription.main : undefined;
    var withInAppMessagesCounter = isInAppMessagesCenterEnabled && isLoggedIn;
    var withQueueCounter = isQueueHeaderCounterEnabled && isLoggedIn && user.analyticsMetadata.subscriptionStatus === "PAYING";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex min-h-full flex-col",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_Header_Header__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                logoLink: headerLogoLink,
                withBanner: withHeaderBanner,
                withInAppMessagesCounter: withInAppMessagesCounter,
                withQueueCounter: withQueueCounter,
                loginWithBackRedirect: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                id: "main",
                className: (0,classnames__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(contentWrapperClassName, "flex-auto"),
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(compositions_Footer_Footer__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MainLayout);


/***/ })

}]);